import React from 'react';
import PropTypes from 'prop-types';

class CookieCategory extends React.Component {
  // ---Getters
  getCategoryTitle(catId) {
    switch (catId) {
      case 'analysis_cookies':
        return this.context.t('Analysis cookies');
      case 'advertising_cookies':
        return this.context.t('Advertising cookies');
      case 'personalization_cookies_':
        return this.context.t('Personalization cookies');
      case 'compulsory_cookies':
        return this.context.t('Compulsory cookies');
      default:
        return '';
    }
  }

  getCategoryDescription(catId) {
    switch (catId) {
      case 'analysis_cookies':
        return this.context.t('These cookies allow us to analyze and measure how you use the website to improve browsing.');
      case 'advertising_cookies':
        return this.context.t('Advertising companies use these cookies to publish adverts that match your interests.');
      case 'personalization_cookies_':
        return this.context.t('These cookies allow us to analyze your user profile and use of the website to give you a personalized experience.');
      case 'compulsory_cookies':
        return this.context.t('These cookies are essential for the website to work correctly.');
      default:
        return '';
    }
  }

  // ---Renders
  render() {
    const { cat, catChange } = this.props;
    return (
      <div className='eu-cookie-compliance-category'>
        <div className="eu-cookie-compliance-category-title">
          <input id={`cookie-category-${cat.id}`} checked={cat.checked} readOnly={cat.required}
            type='checkbox' name='cookie-categories' value='analysis_cookies'
            onChange={() => catChange(cat.id)} />
          <label htmlFor={`cookie-category-${cat.id}`}>{this.getCategoryTitle(cat.id)} </label>
        </div>
        <div className='eu-cookie-compliance-category-description'>
          {this.getCategoryDescription(cat.id)}
        </div>
      </div>
    );
  }
}

CookieCategory.propTypes = {
  cat: PropTypes.object.isRequired,
  catChange: PropTypes.func.isRequired,
};

CookieCategory.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CookieCategory;
